import React, { useState } from 'react';
import AdminPendingReelsSection from '../../components/admin/reels/AdminPendingReelsSection';

const ReelManagementPage: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
        <h1 className="h2">Gönderi Yönetimi</h1>
      </div>

      <p className="text-muted small mb-3">
        İlana bağlı olmayan ve onay bekleyen gönderiler burada listelenir. İlana bağlı gönderiler,
        ilgili ilanın onay ekranında görüntülenir.
      </p>

      <AdminPendingReelsSection
        key={refreshTrigger}
        title="Onay Bekleyen Bağımsız Gönderiler"
        onActionComplete={() => setRefreshTrigger((c) => c + 1)}
      />
    </>
  );
};

export default ReelManagementPage;
